import { lazy, type ReactNode } from 'react';

import { ContentContainer } from '~/eds/src/components/ContentContainer/ContentContainer';

import { useHomeAccess } from '../hooks/useHomeAccess';

const HomePage = lazy(() => import('~/pages/home'));

type Props = {
  fallback: ReactNode;
};

export function HomeGate({ fallback }: Readonly<Props>) {
  const { canUseHome, isLoading } = useHomeAccess();

  if (isLoading) {
    return <ContentContainer loadingContent={{ isLoading: true }} />;
  }

  return canUseHome ? <HomePage /> : fallback;
}
